<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="标签名称">
								<a-input v-model="queryParams.tagName" placeholder="名称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.sex" placeholder="请选择" default-value="">
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
									<a-select-option value="INTERSEX">通用</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/system/tagAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">

				<template slot="sex" slot-scope="record">
					<span class="user-right-detail" v-if="record.sex=='MALE'">男</span>
					<span class="user-right-detail" v-else-if="record.sex=='FEMALE'">女</span>
					<span class="user-right-detail" v-else>通用</span>
				</template>

				<template slot="action" slot-scope="record">
					<a v-has="'/system/tagUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="tagDel(record.id)">
						<a v-has="'/system/tagDel'" href="#">删除</a>
					</a-popconfirm>
				</template>
			</a-table>

			<Tag-form-modal ref="TagForm" :visible="TagFormVisible" :loading="TagFormLoading" :model="TagFormModel"
				@cancel="TagFormCancel" @ok="TagFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import TagFormModal from "@/pages/system/tag/TagForm.vue";
	import {
		tagList,
		tagAdd,
		tagUpdate,
		tagDel
	} from "@/api/system/tag";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '标签名称',
			dataIndex: 'tagName'
		},
		{
			title: '性别',
			scopedSlots: {
				customRender: 'sex'
			}
		},
		{
			title: '用户选择量',
			dataIndex: 'selectedNum'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			TagFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				TagFormVisible: false,
				TagFormLoading: false,
				TagFormModel: null,
				activeTime: [],
				createTime: [],
				photosPreviewVisible: false, // 预览modal显示状态
				photosPreviewImage: '', // 当前预览图片URL
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				tagList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.TagFormModel = null;
				this.TagFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.TagForm && this.$refs.TagForm.initForm) {
						this.$refs.TagForm.initForm();
					}
				});
			},
			update(record) {
				this.TagFormModel = {
					...record
				};
				this.TagFormVisible = true;
			},
			tagDel(id) {
				tagDel(id).then(() => {
					this.fetchTableData();
				})
			},
			TagFormOk() {
				const tagForm = this.$refs.TagForm;
				if (!tagForm || !tagForm.$refs.adminForm) {
					return;
				}
				tagForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...tagForm.form };
					this.TagFormLoading = true;
					if (values.id > 0) {
						tagUpdate(values).then(() => {
							this.TagFormAfter('修改标签成功');
						}).catch(() => {
							this.TagFormLoading = false;
						});
					} else {
						tagAdd(values).then(() => {
							this.TagFormAfter('新增标签成功');
						}).catch(() => {
							this.TagFormLoading = false;
						});
					}
				});
			},
			TagFormCancel() {
				this.TagFormModel = null;
				this.TagFormVisible = false;
				if (this.$refs.TagForm && this.$refs.TagForm.initForm) {
					this.$refs.TagForm.initForm();
				}
			},
			TagFormAfter(message) {
				this.TagFormVisible = false;
				this.TagFormLoading = false;
				if (this.$refs.TagForm && this.$refs.TagForm.initForm) {
					this.$refs.TagForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
		}
	}
</script>

<style lang="less" scoped>
	
</style>